import {
  applyStoreSessionFromUser,
  ENTITY_TYPE_RESTAURANT,
  setEntityType,
} from "../restaurant/entityContext";
import { setStoredOrganizationId } from "../organization/organizationStorage";

export const PARTNER_CHOOSE_BUSINESS_PATH = "/partner/choose-business";

const PENDING_LOGIN_KEY = "partnerPendingLogin";

function normalizeSessionPermissions(sessionUser) {
  if (Array.isArray(sessionUser?.permissions)) {
    return sessionUser.permissions
      .map((code) => String(code || "").trim())
      .filter(Boolean);
  }
  const role = String(sessionUser?.userRole || sessionUser?.role || "")
    .trim()
    .toUpperCase();
  if (role === "ROOT_ADMIN") return ["*"];
  return undefined;
}

export function applyPartnerSession(sessionUser) {
  if (!sessionUser) return;

  const permissions = normalizeSessionPermissions(sessionUser);
  const userWithPermissions =
    permissions !== undefined ? { ...sessionUser, permissions } : { ...sessionUser };

  localStorage.setItem("user", JSON.stringify(userWithPermissions));
  localStorage.setItem("userId", String(sessionUser.userId ?? sessionUser.id ?? ""));
  localStorage.setItem("isAuthenticated", "true");

  localStorage.removeItem("restaurantId");
  localStorage.removeItem("restaurantName");
  localStorage.removeItem("storeId");
  localStorage.removeItem("storeName");
  localStorage.removeItem("organizationId");
  localStorage.removeItem("organizationName");
  localStorage.removeItem("headerEntityType");

  const type = String(sessionUser.type || "").toUpperCase();

  if (type === "ORG" || type === "ORGANIZATION") {
    if (sessionUser.organizationId != null) {
      setStoredOrganizationId(sessionUser.organizationId);
      localStorage.setItem("organizationId", String(sessionUser.organizationId));
    }
    if (sessionUser.organizationName) {
      localStorage.setItem("organizationName", sessionUser.organizationName);
    }
    return;
  }

  if (type === "STR" || type === "STORE") {
    if (applyStoreSessionFromUser(sessionUser)) {
      return;
    }
    if (sessionUser.storeId != null) {
      localStorage.setItem("storeId", String(sessionUser.storeId));
      localStorage.setItem("storeName", sessionUser.storeName || "");
    }
    return;
  }

  if (type === "RST" || type === "RESTAURANT") {
    if (sessionUser.restaurantId != null) {
      localStorage.setItem("restaurantId", String(sessionUser.restaurantId));
      localStorage.setItem("restaurantName", sessionUser.restaurantName || "");
      setEntityType(ENTITY_TYPE_RESTAURANT);
    }
  }
}

export function storePendingPartnerLogin({ identifier, password, contexts }) {
  sessionStorage.setItem(
    PENDING_LOGIN_KEY,
    JSON.stringify({ identifier, password, contexts })
  );
}

export function getPendingPartnerLogin() {
  try {
    return JSON.parse(sessionStorage.getItem(PENDING_LOGIN_KEY) || "null");
  } catch {
    return null;
  }
}

export function clearPendingPartnerLogin() {
  sessionStorage.removeItem(PENDING_LOGIN_KEY);
}

export function formatPartnerContextType(type) {
  if (type === "EAP") return "Eats Business";
  if (type === "RST") return "Restaurant";
  if (type === "STR") return "Store";
  if (type === "ORG") return "Organization";
  return type;
}
